define({
    START: 'START',
    CHANGEPAGE: 'CHANGEPAGE',
    CONTACTUS: 'CONTACTUS',
    TOASTERROR: 'TOASTERROR',
    LOAD: 'LOAD',
    BIND: 'BIND',
});




// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/constants/BaslerLoggingConstants.js